<template>
  <div>
    <div class="msg" v-if="$parent.intake.persoonsData.length > 1">
      Uw kennis en ervaring wordt als leidend gezien voor deze rekening.
    </div>
    <div class="content">

      <h2 class="title">
        <awesomeIcon icon="level-up-alt" style="transform:rotate(90deg); margin-left:7px;" />
        Kennis &amp; ervaring
      </h2>

      <div class="subheader">Wat is uw hoogst genoten opleiding?</div>
      <customInput
        v-model="modelValue.opleiding" type="radio2" name="radiogroup1"
        option="Onopgeleid" label="Geen opleiding"
      />
      <customInput
        v-model="modelValue.opleiding" type="radio2" name="radiogroup1"
        option="VMBO/MAVO/MULO/LBO/VBO" label="VMBO / MAVO / MULO / LBO / VBO"
      />
      <customInput
        v-model="modelValue.opleiding" type="radio2" name="radiogroup1"
        option="MBO/MTS" label="MBO / MTS"
      />
      <customInput
        v-model="modelValue.opleiding" type="radio2" name="radiogroup1"
        option="HAVO/VWO/HBS" label="HAVO / VWO / HBS"
      />
      <customInput
        v-model="modelValue.opleiding" type="radio2" name="radiogroup1"
        option="HBO/HTS/BA" label="HBO / HTS / BA"
      />
      <customInput
        v-model="modelValue.opleiding" type="radio2" name="radiogroup1"
        option="WO/MA/MBA" label="WO / MA / MBA"
      />

      <div class="subheader">Hoe vaak volgt u economisch nieuws?</div>
      <customInput
        v-model="modelValue.nieuws" type="radio2" name="radiogroup2"
        option="Nooit" label="Nooit"
      />
      <customInput
        v-model="modelValue.nieuws" type="radio2" name="radiogroup2"
        option="Jaarlijks" label="Jaarlijks"
      />
      <customInput
        v-model="modelValue.nieuws" type="radio2" name="radiogroup2"
        option="Maandelijks" label="Maandelijks"
      />
      <customInput
        v-model="modelValue.nieuws" type="radio2" name="radiogroup2"
        option="Wekelijks" label="Wekelijks"
      />
      <customInput
        v-model="modelValue.nieuws" type="radio2" name="radiogroup2"
        option="Dagelijks" label="Dagelijks"
      />

      <customInput
        v-model="modelValue.ervaring" type="yesno"
        label="Heeft u ervaring met beleggen?" style="margin-top:20px;"
      />

      <template v-if="modelValue.ervaring == 'Yes'">

        <template v-if="
          $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
          && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
        ">
          <p style="margin-top:20px;font-weight:bold;">
            Met welke diensten heeft u ervaring?
          </p>
          <customInput
            v-model="modelValue.ervaringVermogensbeheer"
            type="yesno2"
            label="Vermogensbeheer"
            boxtype="checkbox"
            :validation="[$parent.checkExperienceInput(modelValue) ? 'notrequired' : 'yes']"
            :watch="$parent.checkExperienceInput(modelValue)"
          />
          <customInput
            v-model="modelValue.ervaringBeleggingsadvies"
            type="yesno2"
            label="Beleggingsadvies"
            boxtype="checkbox"
            :validation="[$parent.checkExperienceInput(modelValue) ? 'notrequired' : 'yes']"
            :watch="$parent.checkExperienceInput(modelValue)"
          />
          <customInput
            v-model="modelValue.ervaringOrderexecutie"
            type="yesno2"
            label="Orderexecutie"
            boxtype="checkbox"
            :validation="[$parent.checkExperienceInput(modelValue) ? 'notrequired' : 'yes']"
            :watch="$parent.checkExperienceInput(modelValue)"
          />
        </template>

        <div class="subheader">
          Heeft u de afgelopen 10 jaar ervaring gehad met onderstaande diensten?
        </div>
        <customInput
          v-model="modelValue.ervaringTrackers" type="yesno"
          label="Trackers / Beleggingsfondsen" boxtype="checkbox"
        />
        <div class="flex-container flex-grow" v-if="modelValue.ervaringTrackers == 'Yes'">
          <customInput
            v-model="modelValue.ervaringTrackersWanneer"
            type="dropdown" label="Laaste belegging" class="listup" :options="[
              {label:'meer dan 5 jaar geleden', value:'meer dan 5 jaar geleden'},
              {label:'2 tot 5 jaar geleden', value:'2 tot 5 jaar geleden'},
              {label:'1 tot 2 jaar geleden', value:'1 tot 2 jaar geleden'},
              {label:'minder dan een jaar geleden', value:'minder dan een jaar geleden'},
            ]"
          />
          <customInput
            v-model="modelValue.ervaringTrackersWaarde"
            type="money" label="Gemiddelde transactie grootte"
          />
          <customInput
            v-model="modelValue.ervaringTrackersTransacties"
            type="dropdown" label="Aantal transacties per jaar" class="listup" :options="[
              {label:'Minder dan 5', value:'minder dan 5'},
              {label:'5 tot 10', value:'5 tot 10'},
              {label:'11 tot 25', value:'11 tot 25'},
              {label:'26+', value:'26+'},
            ]"
          />
        </div>

        <template v-if="
          $parent.intakeAdmin.beleggen.brand !== 'Doelbeleggen'
          && $parent.intakeAdmin.beleggen.brand !== 'OXBY'
        ">
          <customInput
            v-model="modelValue.ervaringAandelen" type="yesno"
            label="Aandelen" boxtype="checkbox"
          />
          <div class="flex-container flex-grow" v-if="modelValue.ervaringAandelen == 'Yes'">
            <customInput v-model="modelValue.ervaringAandelenWanneer"
              type="dropdown" label="Laaste belegging" :options="[
                {label:'meer dan 5 jaar geleden', value:'meer dan 5 jaar geleden'},
                {label:'2 tot 5 jaar geleden', value:'2 tot 5 jaar geleden'},
                {label:'1 tot 2 jaar geleden', value:'1 tot 2 jaar geleden'},
                {label:'minder dan een jaar geleden', value:'minder dan een jaar geleden'},
              ]"
            />
            <customInput
              v-model="modelValue.ervaringAandelenWaarde"
              type="money" label="Gemiddelde transactie grootte"
            />
            <customInput
              v-model="modelValue.ervaringAandelenTransacties"
              type="dropdown" label="Aantal transacties per jaar" :options="[
                {label:'Minder dan 5', value:'minder dan 5'},
                {label:'5 tot 10', value:'5 tot 10'},
                {label:'11 tot 25', value:'11 tot 25'},
                {label:'26+', value:'26+'},
              ]"
            />
          </div>
          <customInput
            v-model="modelValue.ervaringObligaties" type="yesno"
            label="Obligaties" boxtype="checkbox"
          />
          <div class="flex-container flex-grow" v-if="modelValue.ervaringObligaties == 'Yes'">
            <customInput
              v-model="modelValue.ervaringObligatiesWanneer"
              type="dropdown" label="Laaste belegging" :options="[
                {label:'meer dan 5 jaar geleden', value:'meer dan 5 jaar geleden'},
                {label:'2 tot 5 jaar geleden', value:'2 tot 5 jaar geleden'},
                {label:'1 tot 2 jaar geleden', value:'1 tot 2 jaar geleden'},
                {label:'minder dan een jaar geleden', value:'minder dan een jaar geleden'},
              ]"
            />
            <customInput
              v-model="modelValue.ervaringObligatiesWaarde"
              type="money" label="Gemiddelde transactie grootte"
            />
            <customInput
              v-model="modelValue.ervaringObligatiesTransacties"
              type="dropdown" label="Aantal transacties per jaar" :options="[
                {label:'Minder dan 5', value:'minder dan 5'},
                {label:'5 tot 10', value:'5 tot 10'},
                {label:'11 tot 25', value:'11 tot 25'},
                {label:'26+', value:'26+'},
              ]"
            />
          </div>
          <customInput
            v-model="modelValue.ervaringOpties" type="yesno"
            label="Opties" boxtype="checkbox"
          />
          <div class="flex-container flex-grow" v-if="modelValue.ervaringOpties == 'Yes'">
            <customInput
              v-model="modelValue.ervaringOptiesWanneer"
              type="dropdown" label="Laaste belegging" class="listup" :options="[
                {label:'meer dan 5 jaar geleden', value:'meer dan 5 jaar geleden'},
                {label:'2 tot 5 jaar geleden', value:'2 tot 5 jaar geleden'},
                {label:'1 tot 2 jaar geleden', value:'1 tot 2 jaar geleden'},
                {label:'minder dan een jaar geleden', value:'minder dan een jaar geleden'},
              ]"
            />
            <customInput
              v-model="modelValue.ervaringOptiesWaarde"
              type="money" label="Gemiddelde transactie grootte"
            />
            <customInput
              v-model="modelValue.ervaringOptiesTransacties"
              type="dropdown" label="Aantal transacties per jaar" class="listup" :options="[
                {label:'Minder dan 5', value:'minder dan 5'},
                {label:'5 tot 10', value:'5 tot 10'},
                {label:'11 tot 25', value:'11 tot 25'},
                {label:'26+', value:'26+'},
              ]"
            />
          </div>
        </template>

      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntakeExperiencePage',
  emits: ['update:model-value'],
  data() {
    return {
      adminToggle: false,
    };
  },
  props: {
    modelValue: Object,
  },
};
</script>
